import { render, staticRenderFns } from "./GraduatesDirection.vue?vue&type=template&id=7a00d26f&scoped=true&"
import script from "./GraduatesDirection.vue?vue&type=script&lang=js&"
export * from "./GraduatesDirection.vue?vue&type=script&lang=js&"
import style0 from "./GraduatesDirection.vue?vue&type=style&index=0&id=7a00d26f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a00d26f",
  null
  
)

export default component.exports